/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1UserSessionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_USER_SESSION_EVENT_ENTITY_NAME = 'ixm.userauth.v1.UserSessionEvent';
export const ixmUserauthV1UserSessionEventEntity = new schema.Entity<IxmUserauthV1UserSessionEvent>(IXM_USERAUTH_V1_USER_SESSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1UserSessionEvent) => `${entity.metadata?.eventId}` });

